import { render } from "./qoutesSection.vue?vue&type=template&id=d4f9ae42"
import script from "./qoutesSection.vue?vue&type=script&lang=js"
export * from "./qoutesSection.vue?vue&type=script&lang=js"

import "./qoutesSection.vue?vue&type=style&index=0&id=d4f9ae42&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__